module.exports = __webpack_public_path__ + "assets/img/FluidPro-LLC-Logo.61cbdc4b.png";